import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { Document, Packer, Paragraph } from "docx";
import * as XLSX from "xlsx";
import jsPDF from 'jspdf';
import { registerArabicFont } from "../Utils/registerarabicfont.js";
import moment from 'moment';

const formats = [
  { id: "pdf", name: "PDF" },
  { id: "png", name: "PNG" },
  { id: "jpg", name: "JPG" },
  { id: "txt", name: "TXT" },
  { id: "docx", name: "DOCX" },
  { id: "xlsx", name: "XLSX" },
];

const Save = ({ state, setState, templates = [], types = [], context = {} }) => {
  const [selectedtemplateindex, setSelectedtemplateindex] = useState(0);
  const [selectednumberindex, setSelectednumberindex] = useState(0);

  const [templatecontent, setTemplatecontent] = useState('');

  const [format, setFormat] = useState("png");
  const [result, setResult] = useState("");

  const handleCloseModal = () => {
    setState((state) => ({
      ...state,
      modalopen: false,
      modalcontent: null,
      modaltype: null,
      modaltitle: null,
    }));
  };

  function removehyperlinks(text) {
    return text?.replace(/(\d)(?=\d)/g, '$1\u200B');
  }

  useEffect(() => {
    if (!templates || templates.length === 0) {
      setTemplatecontent('Please make sure to set a template in the settings section.')
      return;
    }

    const currentTemplate = templates[selectedtemplateindex];
    if (!currentTemplate || !currentTemplate.content) {
      setTemplatecontent('Please make sure to set a template in the settings section.')
      return
    }

    let content = currentTemplate.content;

    const mergedContext = {
      ...context,
      clientname: context?.clientname || '',
      username: state.user.username || '',
      projectname: removehyperlinks(context.projectname)
    };
    Object.entries(mergedContext).forEach(([key, value]) => {
      const regex = new RegExp(`\\{${key}\\}`, 'g');
      content = content.replace(regex, value ?? '');
    });

    setTemplatecontent(content);
  }, [selectedtemplateindex, selectednumberindex]);


  const saveFile = async () => {
    try {
      if (!context) {
        setResult("No content to save");
        return;
      }

      switch (format) {
        case "pdf": {

          setResult("Saved as PDF");
          break;
        }

        case "png": {
          const element = document.getElementById("receipt-preview");

          if (!element) {
            console.warn("No element found to export as image.");
            break;
          }

          html2canvas(element).then(canvas => {
            canvas.toBlob(blob => {
              if (!blob) return;

              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = context.filename + "." + format;
              link.click();

              setResult(`Saved as ${format.toUpperCase()}`);
            }, `image/${format}`);
          });
          break;
        }
        case "jpg": {
          setResult(`Saved as ${format.toUpperCase()}`);
          break;
        }

        case "txt": {
          const blob = new Blob([templatecontent], { type: 'text/plain' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = context.filename + "." + format;
          link.click();
          setResult("Saved as TXT");
          break;
        }

        case "docx": {
          const formattedClientName = context.clientname.replace(/\s+/g, '_').toLowerCase();
          const currentDate = moment().format('DD_MM_YYYY');

          const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
          registerArabicFont(doc);

          const pageWidth = doc.internal.pageSize.getWidth();
          let currentY = 10;

          doc.setFontSize(20);
          const title = 'Receipt';
          const titleWidth = doc.getTextWidth(title);
          doc.text(title, (pageWidth - titleWidth) / 2, currentY);

          currentY += 10;
          doc.setFontSize(12);

          currentY += 5;
          doc.text('Receipt ID: ' + context.id, 10, currentY);

          currentY += 5;
          doc.text('Received from: ' + context.client, 10, currentY);

          currentY += 5;

          currentY += 5;

          currentY += 5;
          doc.text('For: ' + context.name, 10, currentY);

          currentY += 10;
          doc.text('Signature:', 10, currentY);
          currentY += 15;
          doc.line(10, currentY, 60, currentY);

          currentY += 10;
          doc.setFontSize(10);
          doc.text(moment.unix(context.ts).format('dddd, Do MMMM YYYY'), (pageWidth - 50) / 2, currentY);

          doc.save(context.filename + "." + format);
          setResult("Saved as DOCX");
          break;
        }

        case "xlsx": {
          setResult("Saved as XLSX");
          break;
        }

        case "docx": {
          setResult("Saved as XLSX");
          break;
        }

        default:
          setResult("Unsupported format");
      }
    } catch (err) {
      setResult("Error saving file");
      console.error(err);
    }
  };

  return (
    <div className="modal_body">
      <div className='modal_row'>
        <div className='modal_rowsection'>
          <div className='modal_label'>Template</div>
        </div>
        <div className='modal_rowsection'>
          <select
            className='modal_select'
            value={selectedtemplateindex}
            onChange={e => setSelectedtemplateindex(Number(e.target.value))}>
            {templates.map((t, i) => (
              <option key={'template' + i} value={i}>{t.content.slice(0, 30)}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="modal_row">
        <div className='modal_rowsection'>
          <div className='modal_label'>Format</div>
        </div>
        <div className='modal_rowsection'>
          <select
            className="modal_select"
            value={format}
            onChange={(e) => setFormat(e.target.value)}
          >
            {
              formats
                .filter(f => types.includes(f.id))
                .map(f => (
                  <option key={f.id} value={f.id}>
                    {f.name}
                  </option>
                ))
            }
          </select>
        </div>
      </div>

      <div className='modal_row'>
        <div className='modal_rowsection'>
          <textarea
            className="modal_textarea"
            value={templatecontent}
            onChange={(e) => setTemplatecontent(e.target.value)}
            rows={6}
            placeholder=""
          />
        </div>
      </div>

      <div className="modal_actions">
        {result && <div className="modal_result">{result}</div>}
        <div className="modal_buttons">
          <div className="modal_buttoncontainer">
            <button className="modal_button" onClick={saveFile}>
              💾 Save
            </button>
          </div>
          <div className="modal_buttoncontainer">
            <button className="modal_button" onClick={handleCloseModal}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Save;